import { useState } from "react";

export const useInputValue = (initialValue) => {
  const [value, setValue] = useState(initialValue);
  const onChange = (e) => setValue(e.target.value);
  const onChangeSelect = (e) => {
    console.log(e);
    setValue(e);
  };

  return { value, onChange, onChangeSelect, setValue };
};
